// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"424":"critical","2885":"vendor-critical"}[chunkId] + "." + __webpack_require__.h().slice(0, 8) + ".css";
};